import * as Actions from "@/store/actions.type";

// Parameters:
// -----------
// collection
// region
//
// Returns
// -----------
// Gets the Product Collection from Firebase
export const cachedProductFetch = async (collection, region) => {
  const products = await collection.get();
  return products.empty
    ? parseCollectionData(collection.get(), region)
    : parseCollectionData(products, region);
};
// Parameters:
// -----------
// document
// region
//
// Returns
// -----------
// Parse the Product from the Firebase Collection
export const parseCollectionData = (snapshot, region) => {
  const products = [];
  snapshot.forEach((doc) => {
    products.push({ sku: doc.id, country: region, data: doc.data() });
  });
  return products;
};
// Returns
// -----------
// Fetch the Product from the Firebase
export const loadAllRelatedData = async (state, status) => {
  localStorage.setItem(
    `abi_${status.region}_refresh_time_stamp`,
    JSON.stringify({ timestamp: Date.now() })
  );
  await Promise.all([
    state.$store.dispatch(Actions.FETCH_ALL_COMPONENT, {
      region: status.region,
      hardRefresh: status.hardRefresh
    }),
    state.$store.dispatch(Actions.GET_CATEGORY_INFO, {
      region: status.region,
      hardRefresh: status.hardRefresh
    })
  ]);
};
